import { useQuery } from "@tanstack/react-query"
import { apiClient } from "@/api/client"

export const useWarehouses = () => {
  return useQuery({
    queryKey: ["warehouses"],
    queryFn: () => apiClient.getAllWarehouses(),
    staleTime: 5 * 60 * 1000,
  })
}
